import { AfterViewInit, Component, ComponentFactoryResolver, ComponentRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild, ViewContainerRef } from '@angular/core';
import { AdditionalTaxInfoValue, FieldPermission, SupplierConfigurationPropertiesPayload, SupplierConfigurationPropertiesResponse, SupplierTaxInfo, TaxCountryConfig, TaxIdentifierType, TaxIdTypeInfo } from 'app/profile/models/tax.model';
import { TaxidTypeDisplayChildComponent } from '../taxid-type-display-child/taxid-type-display-child.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { convertKeysFromPascalToCamelCase, isNullOrEmpty, isNullOrUndefined, validateAllFormFields } from 'app/shared/utils/utils';
import { SupplierTaxIDType } from 'app/profile/models/supplier.model';
import * as _ from 'lodash';

@Component({
  selector: 'app-taxid-type-display',
  templateUrl: './taxid-type-display.component.html',
  styleUrls: ['./taxid-type-display.component.scss']
})
export class TaxidTypeDisplayComponent implements AfterViewInit , OnChanges {

  // Input Variables
  @Input('tsl-configProperties') configProperties: SupplierConfigurationPropertiesResponse = null;
  @Input('tsl-currentCountry') currentSelectedCountry: TaxCountryConfig = null;
  
  // Can accept - TaxType , AdditionalTaxType
  @Input('tsl-taxType') taxIdentifierType: TaxIdentifierType = null;

  // Display already filled data
  @Input('tsl-taxData') taxData: SupplierTaxInfo = null;

  // Current Permission
  @Input('tsl-permission') permission: string = null;


  // Output Variables
  @Output("onDataSave") onDataSaveEmitter: EventEmitter<TaxIdTypeInfo[]> = new EventEmitter<TaxIdTypeInfo[]>();

  // View Reference Variables
  @ViewChild("taxIdContainerRef", {static: false,  read : ViewContainerRef }) taxIdContainerRef: ViewContainerRef;
  public componentsReferences = Array<ComponentRef<TaxidTypeDisplayChildComponent>>();

  // Component Variables
  public existingTaxIdTypes: TaxIdTypeInfo[] = [];
  public mandatoryTaxIdTypes: TaxIdTypeInfo[] = [];
  public nonMandatoryTaxIdTypes : TaxIdTypeInfo[] = [];
  public exceptionTaxIdTypes: TaxIdTypeInfo[] = [];
  public currentIndexCounter : number = 0;
  public showAddComponent : boolean = false;
  public isValidationRequired : boolean = false;

  // Form Related Variables
  public taxIdTypeForm : FormGroup;

  constructor(
    private componentResolver: ComponentFactoryResolver,
    private formBuilder : FormBuilder
  ) 
  {
    this.taxIdTypeForm = this.formBuilder.group({});
  }

  ngAfterViewInit(): void {

    if(this.configProperties != null)
    {
      console.log("Display",this.configProperties,this.currentSelectedCountry);
      setTimeout(() => this.initializeComponent(this.configProperties , true), 500);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
      if(changes.configProperties)
      {
        if(!isNullOrUndefined(changes.configProperties.previousValue) && _.isEqual(changes.configProperties.currentValue, changes.configProperties.previousValue) == false)
        {
          console.log("Display",changes.configProperties.currentValue,changes.configProperties.previousValue);
          setTimeout(() => this.initializeComponent(this.configProperties, true), 500);
        }
      }

      if(changes.currentSelectedCountry)
      {
        setTimeout(() => this.UpateComponent(this.currentSelectedCountry), 500);
      }

      if(changes.taxData)
      {
        if(_.isEqual(changes.taxData.previousValue, changes.taxData.currentValue) == false)
        {
          if(!isNullOrUndefined(this.taxIdentifierType) && !isNullOrUndefined(this.taxIdContainerRef))
          {
            this.initializeComponent(this.configProperties, true);
          }
        }
      }
  }

  // Once a new Tax Id Type is selected than add it to exception list so when a new Tax Id Type is selected it will filter existing ones
  updateExceptionList(isFilterRequired: boolean)
  {
    // Check if there are any component references
    if (this.componentsReferences?.length > 0) {

      // Iterate through all component references
      this.componentsReferences.forEach(componentRef => {
        const currentInstance = componentRef.instance;

        // Check if the TaxIdTypeName is selected
        if (isNullOrUndefined(currentInstance?.TaxIdTypeName?.value)) {

          if(isFilterRequired == true)
          {
            // Add the selected TaxIdType to the exception list
            currentInstance.TaxIdList = currentInstance?.TaxIdList?.filter(
              taxId => !this.exceptionTaxIdTypes.some(exception => exception.taxIdType === taxId.taxIdType)
            );
          }

          if(isFilterRequired == false)
          {
            // Add non-mandatory tax IDs to the TaxIdList that are not part of the exception list
            const nonMandatoryTaxIds = this.nonMandatoryTaxIdTypes.filter(
              taxId => (!this.exceptionTaxIdTypes.some(exception => exception.taxIdType === taxId.taxIdType) && !currentInstance?.TaxIdList?.some(exception => exception.taxIdType === taxId.taxIdType))
            );

            // Merge the current TaxIdList with the filtered non-mandatory tax IDs
            currentInstance.TaxIdList = [...(currentInstance.TaxIdList || []), ...nonMandatoryTaxIds];
          }
        }
      });
    }
  }

  initializeComponent(configPropertiesValue : SupplierConfigurationPropertiesResponse, clearExistingComponent: boolean)
  {
    if(configPropertiesValue != undefined && configPropertiesValue != null && (configPropertiesValue.taxIdTypes?.length > 0 || configPropertiesValue.additionalTaxIdTypes?.length > 0))
    {

      if(clearExistingComponent == true)
      {
        this.exceptionTaxIdTypes = [];
        this.taxIdContainerRef?.clear();
        this.componentsReferences = [];
        this.currentIndexCounter = 0;
      }

      // Skip all the Tax Id's which are already
      var skipTaxIdList = [];

      if(this.exceptionTaxIdTypes?.length > 0)
      {
        this.exceptionTaxIdTypes?.forEach(x => skipTaxIdList.push(x.taxIdType));
      }

      // Bifurcate Tax Id Types
      if(!isNullOrUndefined(this.taxIdentifierType))
      {
        this.mandatoryTaxIdTypes = configPropertiesValue[this.taxIdentifierType]?.filter(x => (skipTaxIdList.includes(x.taxIdType) == false) && x.isMandatory == true);
        this.nonMandatoryTaxIdTypes = configPropertiesValue[this.taxIdentifierType]?.filter(x => (skipTaxIdList.includes(x.taxIdType) == false) && x.isMandatory == false);
      }

      var existingTaxData = (this.taxIdentifierType == TaxIdentifierType.AdditionalTaxType) ? convertKeysFromPascalToCamelCase(this.taxData?.AdditionalTaxIds) : null;
      this.permission =  FieldPermission.ReadWrite;

      // For All Mandatory Components
      if(this.mandatoryTaxIdTypes.length > 0)
      {
        this.mandatoryTaxIdTypes.forEach(x => {
          if(existingTaxData?.some(y => y?.taxIdType == x?.taxIdType) == true)
          {
            this.createComponent([x], false , existingTaxData?.filter(y => y.taxIdType == x.taxIdType)[0]);
          }
          else
          {
            this.createComponent([x], false , null);
          }
        });
      }

      // For Non Mandatory Components
      if(this.nonMandatoryTaxIdTypes.length > 0)
      {
        var existingNonMandatoryData = this.nonMandatoryTaxIdTypes.filter(nonMandatory =>
          existingTaxData?.some(existing => existing.taxIdType === nonMandatory.taxIdType)
        );

        var nonExistingNonMandatoryData = this.nonMandatoryTaxIdTypes.filter(nonMandatory =>
          !existingTaxData?.some(existing => existing.taxIdType === nonMandatory.taxIdType)
        );

        if(existingNonMandatoryData?.length > 0)
        {
          existingNonMandatoryData.forEach(x => {
            this.createComponent([x], true , existingTaxData?.filter(y => y.taxIdType == x.taxIdType)[0]);
          });

          if(nonExistingNonMandatoryData?.length > 0)
          {
            this.createComponent(nonExistingNonMandatoryData, true , null);
          }
        }
        else
        {
          this.createComponent(this.nonMandatoryTaxIdTypes , true , null);
        }
      }
    }
  }

  createComponent(taxIdTypeList : TaxIdTypeInfo[] ,canChildBeDeleted: boolean , taxIdData : AdditionalTaxInfoValue)
  {
    // Create a new child component
    let taxIdTypeChildComponentResolver = this.componentResolver.resolveComponentFactory(TaxidTypeDisplayChildComponent);
    let currentTaxIdComponent = this.taxIdContainerRef.createComponent(taxIdTypeChildComponentResolver);

    // Assign Values
    let currentTaxIdComponentInstance = currentTaxIdComponent.instance;
    currentTaxIdComponentInstance.TaxIdList = (taxIdTypeList?.length > 0) ? this.GetFinalTaxIdList(taxIdTypeList) : [];
    currentTaxIdComponentInstance.taxIdData = (!isNullOrUndefined(taxIdData)) ? taxIdData : null;
    currentTaxIdComponentInstance.canChildBeDeleted =  this.checkIsDeleteButtonAvailable(canChildBeDeleted, taxIdData?.taxIdType);
    currentTaxIdComponentInstance.parentTaxIdTypeComponent = this;
    currentTaxIdComponentInstance.currentComponentIndex = this.currentIndexCounter + 1;
    currentTaxIdComponentInstance.currentSelectedCountry = this.currentSelectedCountry;
    currentTaxIdComponentInstance.permission = this.permission;

    // Flag to determine if validation needs to be skipped or not
    // For cases when TNumber is not required
    currentTaxIdComponentInstance.isValidationSkipped = this.allTaxIdTypeValidationSkipped(currentTaxIdComponentInstance.TaxIdList);

    this.currentIndexCounter = this.currentIndexCounter + 1;

    // Add component to component Array
    this.componentsReferences.push(currentTaxIdComponent);

    // If There are any unselected tax Id type then disable ShowTaxForm
    this.showAddComponent = this.isAddButtonRequired();
  }


  GetFinalTaxIdList(taxIdList: TaxIdTypeInfo[]) : TaxIdTypeInfo[]
  {
    let currentTaxIdList = taxIdList;
    if(this.exceptionTaxIdTypes.length == 0)
    {
      return currentTaxIdList;
    }

    this.exceptionTaxIdTypes.forEach(x => {
      if(currentTaxIdList.some(y => y.taxIdType == x.taxIdType) == true)
      {
        currentTaxIdList = currentTaxIdList.filter(y => y.taxIdType != x.taxIdType);
      }
    });

    return currentTaxIdList;
  }

  AddComponent()
  {
    if(this.exceptionTaxIdTypes?.length == this.nonMandatoryTaxIdTypes.length)
    {
      this.showAddComponent = false;
    }

    this.createComponent(this.nonMandatoryTaxIdTypes, true , null);
  }

  UpateComponent(selectedCountry : TaxCountryConfig)
  {
    // For All Components update the tax country config
    if(this.componentsReferences?.length > 0)
    {
      this.componentsReferences.forEach(x => 
      {
        x.instance.currentSelectedCountry = selectedCountry;
      });
    }
  }

  // When the component is deleted than remove the Tax Id Type from Exception list and component ref array
  deleteComponent(indexToDelete: number)
  {
    if(this.componentsReferences?.length > 1)
    {
      // Find the current Component Ref
      let currentComponentRef = this.componentsReferences.filter(x => x.instance.currentComponentIndex == indexToDelete)[0];
      
      // Reset ExceptionTax Id List
      if(!isNullOrUndefined(currentComponentRef.instance.TaxIdTypeName?.value))
      {
        this.exceptionTaxIdTypes = this.exceptionTaxIdTypes.filter(x => x.taxIdType != currentComponentRef.instance.TaxIdTypeName?.value);
      }

      // Find the Index of current instance from view ref and remove it
      let currentCompoenntViewRefIndex = this.taxIdContainerRef.indexOf(currentComponentRef.hostView as any);
      this.taxIdContainerRef.remove(currentCompoenntViewRefIndex);

      // Remove the compoent from component references
      this.componentsReferences = this.componentsReferences.filter(x => x.instance.currentComponentIndex != indexToDelete);

      // If There are any unselected tax Id type then disable ShowTaxForm
      this.showAddComponent = this.isAddButtonRequired();

      // If Only one reference in componentReferenceList than enable tax form
      if(this.componentsReferences?.length == 1)
      {
        // The first form will not be disabled
        if(this.componentsReferences[0].instance.canChildBeDeleted == true)
        {
          this.componentsReferences[0].instance.isFormDisabled = false;
        }
      }

      // Update the Tax IdList 
      this.updateExceptionList(false);
    }
  }

  // Logic to decide if Add Button Needs to be present or not
  showAddButton()
  {
    if(this.configProperties?.taxIdTypes?.length > 1)
    {
      // Reset Add Button if Required
      if(this.exceptionTaxIdTypes?.length == this.nonMandatoryTaxIdTypes.length)
      {
        this.showAddComponent = false;
        return;
      }

      if(this.exceptionTaxIdTypes.length > 0)
      {
        this.showAddComponent = true;
      }
      else
      {
        this.showAddComponent = false;
      }
    }
    else
    {
      this.showAddComponent = false;
    }
  }

  allTaxFormValueSelected() : boolean
  {
    let isAllTaxFormSelected = true;

    if(this.componentsReferences?.length > 0)
    {
      this.componentsReferences?.forEach(x => {
        let currentComponentRef = x.instance;

        if(isNullOrUndefined(currentComponentRef?.TaxIdTypeName?.value))
        {
          isAllTaxFormSelected = false;
          return isAllTaxFormSelected;
        }
      })
    }

    return isAllTaxFormSelected;
  }

  isAddButtonRequired(): boolean {

    // Check if there are no component references and the exception list is null or empty
    if (!this.componentsReferences?.length && (!this.exceptionTaxIdTypes || this.exceptionTaxIdTypes.length === 0)) {
      return true;
    }
  
    // If components are present
    if (this.componentsReferences?.length > 0) {
      // Check if the exception list does not have all the items in the taxIdList
      const allTaxIdTypes = [...this.mandatoryTaxIdTypes, ...this.nonMandatoryTaxIdTypes];
      const exceptionTaxIdTypesSet = new Set(this.exceptionTaxIdTypes.map(x => x.taxIdType));

      // If total amount of dynamic component references is equal to the total amount of tax ID types, the Add button is not required
      if(this.componentsReferences?.length == allTaxIdTypes.length)
      {
        return false;
      }
  
      const hasUnselectedTaxIdTypes = allTaxIdTypes.some(
        taxIdType => !exceptionTaxIdTypesSet.has(taxIdType.taxIdType)
      );
  
      // If there are unselected tax ID types, the Add button is required
      return hasUnselectedTaxIdTypes;
    }
  
    // Default case: Add button is not required
    return false;
  }

  allTaxIdTypeValidationSkipped(taxIdTypeList: TaxIdTypeInfo[]): boolean
  {
    var isAllTaxIdTypeValidationSkipped = true;
    
    taxIdTypeList.forEach(x => 
    {
      if(x.taxIdTypeValidationInfo?.isRequired == true)
      {
        isAllTaxIdTypeValidationSkipped = false;
        return isAllTaxIdTypeValidationSkipped
      }
    });

    return isAllTaxIdTypeValidationSkipped;
  }

  isFormValid() : boolean
  {
    // Check if All the Child components are valid or not
    let isFormValidVal = true;
    let validTaxIdList: TaxIdTypeInfo[] = [];

    if(this.componentsReferences?.length > 0)
    {
      this.componentsReferences.forEach(x => {
        let currentInstance = x.instance;

        if(currentInstance.isFormValid() == false)
        {
          isFormValidVal = false;
          return isFormValidVal;
        }
      });
    }

    return isFormValidVal;
  }

  getFormData(): AdditionalTaxInfoValue[]
  {
    let finalTaxIdList : AdditionalTaxInfoValue[] = [];

    if(this.componentsReferences?.length > 0)
    {
      this.componentsReferences.forEach(x => {
        let currentInstance = x.instance;
        let currentTaxIdValue = currentInstance.getFormData();

        if(currentTaxIdValue != null)
        {
          finalTaxIdList.push(currentTaxIdValue);
        }
      });
    }

    return finalTaxIdList;
  }

  clearForm()
  {
    if(this.componentsReferences?.length > 0) 
    {
        this.componentsReferences = [];
    }
  }

  checkIsDeleteButtonAvailable(curentValue : boolean, taxIdType : string) : boolean
  {
    if(!isNullOrUndefined(this.permission) && !isNullOrUndefined(taxIdType) && this.permission?.toLowerCase() == FieldPermission.Read)
    {
      return false;
    }

    return curentValue;
  }
}